import React from 'react';

const uploadTargetRadioButton = (props) => (
  <input
    id={props.value}
    className="form-check-input mr-2"
    type="radio"
    name="source"
    value={props.value}
    checked={props.albumOption === props.value}
    onChange={props.handleChange}
  />
 );

export default uploadTargetRadioButton;
